<template>
    <v-form>
        <v-row class="mx-0 pt-8">
            <v-col cols="12">
                <h2>Основная информация</h2>
            </v-col>
            <v-col cols="12">
                <CompanyGeneral :company-data="general" @change="generalChange"/>
            </v-col>
        </v-row>
        <div class="spacer"></div>
        <v-row class="mx-0 pt-8">
            <v-col cols="12">
                <h2>Контакты компании</h2>
            </v-col>
            <v-col cols="12" class="mx-0">
                <CompanyContacts :contacts-data="contacts" @delete="contactDelete" @change="contactChange"/>
            </v-col>
        </v-row>
        <v-row class="mx-0 pt-8">
            <v-col cols="12">
                <h2>Юридическая информация</h2>
            </v-col>
            <v-col cols="12" class="mx-0">
                <CompanyLaw :company-data="law" @change="lawChange"/>
            </v-col>
        </v-row>
        <div class="spacer"></div>
        <v-row class="mx-0">
            <v-col cols="12" class="text-center text-sm-right">
                <v-btn icon color="teal" @click="$emit('save')">Сохранить</v-btn>
            </v-col>
        </v-row>
        <v-snackbar v-model="snackOpen" :color="snackColor">
            <div v-if="snackText">
                {{ snackText }}
            </div>
            <div v-if="snackDelete" class="d-flex justify-space-between">
                <v-btn text @click="deleteImage">Удалить</v-btn>
                <v-btn text @click="resetSnack">Закрыть</v-btn>
            </div>
        </v-snackbar>
    </v-form>
</template>

<script>
    import UserDataMixin from "./UserDataMixin"
    import CompanyContacts from "./CompanyContacts"
    import CompanyGeneral from "./CompanyGeneral"
    import CompanyLaw from "./CompanyLaw"

    import { MixinAppSnack } from "../../../../mixins"

    export default {
        name: "CompanyInfo",
        props: ['dataKey'],
        mixins: [MixinAppSnack, UserDataMixin],
        components: {CompanyContacts, CompanyGeneral, CompanyLaw},
        data() {
            return {

            }
        },
        computed: {
            contacts() {
                return this.baseUserData.contacts || [];
            },
            general() {
                return this.baseUserData.general || {}
            },
            law() {
                return this.baseUserData.lawData || {}
            }
        },
        methods: {
            contactChange(data) {
                // ебанная мистика...
                // this.baseUserData.contacts = data;
                this.emitUpdate();
            },
            generalChange(data) {
                // ебанная мистика.....
                // this.baseUserData.general = data;
                this.emitUpdate();
            },
            lawChange(data) {
                // ебанная мистика.......
                // this.baseUserData.lawData = data;
                this.emitUpdate();
            },
            contactDelete(data) {
                let contacts = this.baseUserData.contacts || [];
                contacts = contacts.filter(item => item.id !== data.id);
                this.baseUserData.contacts = contacts;
                this.emitUpdate();
            },
            emitUpdate() {
                this.$emit('update', this.getEmitData());
            },
            getEmitData() {
                return {
                    key: this.dataKey,
                    data: this.baseUserData
                }
            }
        },
    }
</script>

<style scoped>
    h2 {
        text-transform: uppercase;
    }
</style>